'use client';

import React from 'react';

type TechnicalDataProps = {
  translatedAttributes: Array<{ key: string; value: string }>;
};

function TechnicalData({ translatedAttributes }: TechnicalDataProps) {
  if (!translatedAttributes) return;

  return (
    <dl className="divide-y divide-gray-200">
      {translatedAttributes.map(({ key, value }, index) => (
        <div className="flex justify-between p-3" key={`technical-${key}-${index}`}>
          <dt>{key}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}

export default TechnicalData;
